import * as React from "react";
export function SvgNarrowSortArrowAscending(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg viewBox="0 0 9 19" {...props}>
      <path fill="#333" d="M6.5 9l-2-3.6-2 3.6H4v5h1V9z" />
    </svg>
  );
}
